import { createAction } from 'redux-actions';

export const PLACE_TRASH = 'PLACE_TRASH';
export const SHOW_TRASH = 'SHOW_TRASH';
export const HIDE_TRASH = 'HIDE_TRASH';

export const place = createAction(PLACE_TRASH);
export const show = createAction(SHOW_TRASH);
export const hide = createAction(HIDE_TRASH);
